import React from 'react';
import {LoadingStyle} from '../StyledComponents/LoadingScreen'
export const LoadingScreen = () => {
    return(
        <div>
            <LoadingStyle/>
        </div>
    )
};